<template>
    <Loader v-if="loading"/>
    <UserWrapper :title="'一覧に戻る'" v-else>
        <div class="main-container" style="padding-top:20px">
            <div class="container" style="padding: 0;background: #fff !important;">
                <div class="msg-content">
                    <div class="profile-header desktop">
                        <div class="profile-header-block">
                            <p class="desktop"></p>
                            <p class="desktop"></p>
                            <p class="company-name-block w-65">{{ contact.companyName }} {{ contact.sender }}</p>
                            <p class="sent-date">{{ receivedDate }}</p>
                        </div>
                        <div>
                            <p class="profile-subject-block">{{ contact.subject }}</p>
                        </div>
                    </div>
                    <table class="profile-header mobile">
                        <td class="d-flex d-sm-none flex-row justify-content-between pb-0">
                            <div class="w-65 font-15 font-bold text-left">{{ contact.companyName }}</div>
                            <div class="font-12">{{ receivedDate }}</div>
                        </td>
                        <td class="d-flex d-sm-none flex-row justify-content-between text-left">
                            <div class="font-bold font-15">{{ contact.sender }}</div>
                        </td>
                        <td class="d-flex d-sm-none flex-row justify-content-between text-left">
                            <div class="font-12">{{ contact.subject }}</div>
                        </td>
                    </table>
                    <div class="button-container d-flex justify-content-center full-button-container" v-if="showReplyButtons">
                        <button class="btn btn-secondary cancel-text-button mr-5" @click="refrainFromApply()">今回は控える</button>
                        <button class="btn btn-primary question-button mr-5" v-if="contact.question_request" @click="submitQuestion()">質問する</button>
                        <button class="btn btn-info submit-text-button" v-html="submitButtonText" @click="submit()"></button>
                    </div>
                    <div class="preview-block">
                        <div class="preview-body" v-html="renderedBody">
                        </div>
                    </div>
                    <div class="jd-info" v-if="contact.jd_display && contact.jd_snapshot">
                        <p class="jd-title" @click="openJdModal">{{ contact.jd_snapshot.job_title }}</p>
                    </div>
                </div>
                <div class="button-container d-flex mobile-button-container" :style="buttonClass" v-if="showReplyButtons">
                    <button class="btn btn-secondary cancel-text-button mr-5" @click="refrainFromApply()">今回は控える</button>
                    <button class="btn btn-primary question-button mr-5" v-if="contact.question_request" @click="submitQuestion()">質問する</button>
                    <button class="btn btn-info submit-text-button" v-html="submitButtonText" @click="submit()"></button>
                </div>
                <IndividualJdModal 
                    v-if="showJdModal"
                    :modalData="{
                        jd: contact.jd_snapshot,
                        isOpen: showJdModal,
                        isReplied: contact.is_replied,
                        isQuestion: contact.question_request,
                        companyName: contact.companyName,
                        buttonText: submitButtonText
                    }"
                    @modal-action="handleModalAction"
                />
            </div>

            <!-- <div class="info-container">
                <p style="font-weight: bold;">Bloomキャリア登録　運営事務局より</p>
                <ul>
                    <li>募集ポジションの採用活動は、企業の採用計画や他の応募者の選考状況などにより終了となることもあります。</li>
                    <li>書類の追加提出が必要となる場合があります。</li>
                    <li>応募後の選考結果などの連絡は、基本的に企業から直接メールで届きます。</li>
                </ul>
            </div> -->
            <div class="container reply-container mt-4" v-if="contact.is_replied">
                <div class="reply-full">
                    <div class="d-flex">
                        <span class="reply-title replied-date">回答日</span>
                            <span class="reply-detail">{{ repliedDate}}</span>
                        </div>
                    <div class="d-flex">
                        <span class="reply-title">回答内容</span>
                        <span class="reply-detail">{{ contact.user_response }}</span>
                    </div>                   
                </div>
                <div class="reply-head-responsive">
                    <div class="d-flex">
                        <span class="reply-title replied-date">回答日</span>
                        <span class="reply-detail">{{ repliedDate}}</span>
                        <span class="reply-title replied-response">回答内容</span>
                        <span class="reply-detail">{{ contact.user_response }}</span>
                    </div>            
                </div>
                <div class="d-flex reply-responsive" style="border: 1px solid #ccc" v-if="userQuestion">
                    <span class="reply-title">記入内容</span>
                    <span class="reply-detail-full">{{ contact.user_question }}</span>
                </div>
            </div>
        </div>

        <ContactReply 
            :contact="contact"
            :questionRequest="askQuestion"
            :refrain="refrain"
            :isFormSubmitting="isFormSubmitting"
            :isSubscribed="checkIfSubscribed"
            @hideModal="cancel"
            @submitForm="submitForm"
            v-if="showReply"
        />

        <ContactConfirmation
            :contact="contact"
            :questionRequest="askQuestion"
            :refrain="refrain"
            @redirectToContactList="redirectToContactList"
            v-if="showConfirmationModal"
        />

        <ContactError
            :contact="contact"
            @redirectToProfile="redirectToProfile"
            v-if="showError"
        />

    <template v-slot:footer>
        <Footer/>
    </template>
    </UserWrapper>
</template>

<script>
import DOMPurify from 'dompurify';
import moment  from 'moment';
import UserWrapper from '../UserWrapper.vue';
import Api from '@/config/api';
import ContactReply from './ContactReply.vue'
import ContactConfirmation from './ContactConfirmation.vue';
import ContactError from './ContactError.vue';
import IndividualJdModal from './IndividualJdModal.vue';
import { mapActions, mapGetters } from "vuex";
import Loader from '../Loader.vue';
import Footer from '../Footer.vue';
import { mapMutations } from 'vuex/dist/vuex.common.js';
export default {
    name: 'ContactDetails',
    components: { UserWrapper, ContactReply, ContactConfirmation, Loader, Footer, ContactError, IndividualJdModal },
    data() {
        return {
            contact:{},
            showReply:false,
            askQuestion:false,
            refrain: false,
            showConfirmationModal: false,
            isFormSubmitting: false,
            loading:false,
            showError: false,
            showJdModal: false
        }
    },
    computed: {
        ...mapGetters({
            profile: "getProfile",
            getUnreadContactCount: "getUnreadContactCount"
        }),
        buttonClass() {
            if(this.contact.question_request) {
                return 'justify-content: space-around';
            } else {
                return 'justify-content: space-evenly';
            }
        },
        isMobile() {
            console.log(window.innerWidth <= 768);
            return window.innerWidth <= 768;
        },
        userQuestion(){
            return this.contact.user_question;
        },
        renderedBody(){
            return DOMPurify.sanitize(this.processEmailBody(this.contact.body),{ ADD_ATTR: ['target']});
        },
        submitButtonText() {
            if (this.contact.contact_type === '応募案内') {
                return '応募する';
            }
            else if (this.contact.contact_type === 'カジュアル面談') {
                return 'カジュアル面談に\r\n参加する';
            }
            else {
                return '<span>選考に応募して</span><br/><span>面接に参加する</span>';
            }
        },
        receivedDate() {
            return moment(this.contact.sent_date).format("YYYY[年]MM[月]DD[日]");
        },
        repliedDate() {
            return moment(this.contact.replied_date).format("YYYY[年]MM[月]DD[日]");
        },
        checkIfSubscribed(){
            // console.log(this.profile.other_companies)
            return this.profile.other_companies.includes(this.contact.company);
        },
        isOtherNotifications(){
            return this.contact.contact_type === 'その他通知'
        },
        showReplyButtons() {
            return !this.isOtherNotifications && !this.contact.is_replied;
        }
    },
    methods: {
        ...mapActions({
            setProfile: "setProfile",
        }),
        ...mapMutations({
            setUnreadContact: "setUnreadContact"
        }),
        processEmailBody(htmlString) {
            // Updated regex to capture the entire href attribute including quotes
            const linkRegex = /<a[^>]+href=["']([^"']*)["']/g;
            
            const processedHTML = htmlString.replace(linkRegex, (match, link) => {
                // Skip empty, undefined, or # links
                if (!link || link === "undefined" || link === "#" || link.trim() === "") {
                    return match.replace(/<a/i, '<span').replace(/href=["'][^"']*["']/i, '');
                }
                
                // Add https:// if needed
                if (!/^https?:\/\//i.test(link)) {
                    return match.replace(link, `https://${link}`);
                }
                
                return match;
            });
            // Find and linkify valid URLs that aren't already in <a> tags
            const urlRegex = /(?<!<a[^>]*)(https?:\/\/[^\s<]+|www\.[^\s<]+\.[^\s<]+)(?![^<]*>)/g;
            return processedHTML.replace(urlRegex, url => `<a href="${url}">${url}</a>`);
        },
        submit(){
            this.closeJdModal();
            if(!this.checkIfSubscribed) {
                this.showError = true;
            } else {
                this.showReply = true;
            }
        },
        submitQuestion(){
            this.closeJdModal();
            if(!this.checkIfSubscribed) {
                this.showError = true;
            } else {
                this.showReply = true;
                this.askQuestion = true;
            }
        },
        refrainFromApply(){
            this.closeJdModal();
            if(!this.checkIfSubscribed) {
                this.showError = true;
            } else {
                this.showReply = true;
                this.refrain = true;
            }
        },
        openJdModal(){
            console.log('open');
            this.showJdModal = true;
        },
        closeJdModal(){
            this.showJdModal = false;
        },
        handleModalAction(action) {
            const actionMap = {
                'close': this.closeJdModal,
                'submit': this.submit,
                'question': this.submitQuestion,
                'refrain': this.refrainFromApply
            };
            
            if (actionMap[action]) {
                actionMap[action]();
            }
        },
        async submitForm(data){
            this.closeJdModal();
            try {
                this.isFormSubmitting = true;
                const token = await this.$auth.getToken();
                const headers = {
                    Authorization: `Bearer ${token}`,
                };
                const contact = await this.axios({
                    method: 'put',
                    url: Api.url(Api.endpoints.reply(this.contact._id)),
                    headers: headers,
                    data: {
                        user_response: data.user_response,
                        question: data.user_question
                    }
                }); 

                if(contact) {
                    if(this.contact.file_upload_request.length > 0 ) this.fileRequest=true;
                    this.cancel();
                    this.contact = contact.data.data;
                    this.showConfirmationModal = true;
                }
                this.isFormSubmitting = false;
            } catch(err){
                const hasError = err && err.response && err.response.data && err.response.data.error;
                const isSubscriptionError = hasError && err.response.data.error === 'Subscription Error';
                if(isSubscriptionError){
                    this.isFormSubmitting = false;
                    this.showError=true;
                    this.showConfirmationModal = false;
                    this.showReply=false;
                }
                this.isFormSubmitting = false;
            }
        },
        redirectToContactList(hasFileRequest) {
            this.clearAll();
            // console.log(hasFileRequest);
            if(hasFileRequest) {
                this.$router.push({ name: 'userProfile', query: { uploadFile: 'true' }});
            } else {
                this.$router.push({ name: 'contactList' });
            }
            // return this.$router.push({ name: 'contactList'});
        },
        redirectToProfile(){
            this.$router.push({name: 'home', query: { openCompanyShare: 'true' }});
        },
        // submitQuestion() {
        //     this.showReply = true;
        //     this.askQuestion = true;
        // },  
        // refrainFromApply(){
        //     this.showReply = true;
        //     this.refrain = true;
        // },

        //hideModal
        cancel(){
            this.showReply = false;
            this.askQuestion = false;
            this.refrain = false;
            this.showError = false;
        },
        clearAll(){
            this.showReply = false;
            this.askQuestion = false;
            this.refrain = false;
            this.showConfirmationModal = false;
        },
        async getContactDetails() {
            try {
                this.loading = true;
                const token = await this.$auth.getToken();
                const headers = {
                    Authorization: `Bearer ${token}`,
                };
                const { id } = this.$route.params;
                const contact = await this.axios({
                    method: 'get',
                    headers: headers,
                    url: Api.url(Api.endpoints.contactDetail(id)),
                })

                this.contact = contact.data.data.contact;
                // this.jobseekerJd = contact.data.data.jobseekerJd;
                this.loading = false;
                if(!this.contact.is_read){
                    await this.changeStatusToRead();
                }
                // console.log(this.contact);
            } catch (err) {
                // console.log(err);
                // console.log(err.response);
                this.loading = false
                if(err.response.status === 422){
                    return this.$router.push({name: 'contactList'})
                }
            }
        },
        async changeStatusToRead() {
            try {
                const token = await this.$auth.getToken();
                const headers = {
                    Authorization: `Bearer ${token}`,
                };
                const { id } = this.$route.params;
                const contact = await this.axios({
                    method: 'put',
                    headers: headers,
                    url: Api.url(Api.endpoints.changeReadStatus(id)),
                })
                this.contact = contact.data.data;
                if(this.getUnreadContactCount > 0) {
                    this.setUnreadContact(this.getUnreadContactCount -1);
                }
            } catch (err) {
                console.log(err);
            }
        }
    },
    async created(){
        await this.getContactDetails();
        Object.keys(this.profile).length === 0 && (await this.setProfile());
    }
}
</script>

<style scoped>

.jd-info {
    padding: 20px 50px;
}

.jd-title {
    border: 1px solid #b3b3b3;
    padding: 20px 10px;
    border-radius: 3px;
    color: #036AC9;
    font-weight: bold;
    cursor: pointer;
    font-size: 18px;
}
.w-65 {
    width: 65%;
}

.left-pointing-triangle::after {
  content: "\25C0 \FE0E";
}

.font-bold {
    font-weight: bold;
}

.font-12 {
    font-size: 12px;
}

.font-15 {
    font-size: 15px;
}

.text-left {
    text-align: left;
}

>>>.linkified {
    word-wrap: break-word;
}

.msg-content {
    word-break: break-word;
}

.reply-head-responsive {
    display: none;
}

.reply-title {
    width: 20%;
    background-color: rgba(0, 108, 107, 0.1)
}

.reply-detail-full {
    width: 80%;
    text-align: left;
    border: none !important;
    border-left: 1px solid #ccc !important;
    word-wrap: break-word;
    white-space: pre-wrap;
}

.reply-detail {
    width: 20%;
}
.reply-container{
    text-align: center;
    font-size: 16px;
    color: #2F2E41;
}
.reply-container span {
    border: 1px solid #ccc;
    padding: 10px;
}
>>>.profile-detail-block {
    padding: 0px !important;
    background-color: #fff !important;
}
.contact-btn {
    float: left;
    /* padding: 0px !important; */
}

.contact-btn:hover {
    text-decoration: none;
}

.contact-btn.mobile{
    display: none;
}

.preview-block {
    margin-top: 15px;
    font-size: 18px;
    padding-left:50px;
    padding-right: 50px;
    padding-bottom: 18px;
}
 .preview-body{
  /* white-space: pre-line; */
  word-break: break-word;
} 


.mobile-button-container {
    display: none !important;
    position: sticky;
    top: 0;
    bottom: 0;

}
.text-center{
  text-align: center;
}

.profile-divider{
  border-bottom: 1px solid #ccc;
  width: 95%;
  margin: 0 auto;
}
.profile-header {
  padding: 20px;
  text-align: center;
  /* border-bottom: 0.5px solid gray; */
}

.profile-header.mobile {
    display: none;
}

.profile-header-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sent-date {
  margin: 0;
  text-align: right;
}

.profile-subject-block {
  text-align: center;
}

.company-name-block{
   text-align: center;
   font-size: 20px;
   font-weight: 600;
   margin-right: 80px;
}

.profile-subject-block{
   text-align: center;
   font-size: 20px;
   font-weight: lighter;
}

.custom-modal{
    padding: 0px;
    border: 10px solid #617776 !important;
    box-shadow: 0 0 10px rgba(0.0.0.0.2);
}

.button-container{
    padding: 30px;
    background: #f2f5f7
}

.info-container{
    padding: 10px;
    background: #f2f5f7;
    margin-top: 20px;
}

.buttons {
    padding: 20px;
}

.submit-text-button,
.question-button,
.cancel-text-button {
    padding: 0px !important;
    width: 160px !important;
    height: 60px !important;
    white-space: pre-line;
    /* border: 1px solid !important; */
    border-radius: 1px !important ;
}

.btn-info {
    background-color: #006c6b;
}

.question-button {
    background-color: #2F80ED;
    border-color: #2F80ED;
}


@media(max-width: 767px) {

    .jd-info {
        padding: 5px;
    }

    .main-container {
        padding-top: 5px !important;
    }

    .msg-content {
        padding: 5px;
    }

    .profile-header.desktop {
        display: none;
    }

    .profile-header.mobile {
        display: block;
    }

    >>>.profile-detail-block table td {
        padding: 0px !important;
        min-height: 0px !important;
    } 

    .full-button-container {
        display: none !important;
    }

    .mobile-button-container {
        display: flex !important;
    }
    .reply-full {
        display: none;
    }
    .reply-container {
        font-size: 12px;
        border: none;
        margin-top: 0px !important;
        padding-left: 0px;
        padding-right: 0px;
    }
    .reply-container span {
        border: none;
    }
    .reply-head-responsive {
        display: block;
        font-size: 12px;
    }

    .reply-detail-full {
        border-left: none !important
    }

    .reply-responsive .reply-title{
        width: 100%;
    }

    .reply-head-responsive .reply-title.replied-date {
        width: 35%;
    }

    .reply-title.replied-response {
        width: 25%;
    }
    .reply-head-responsive .reply-detail {
        width:70%;
    }
    .reply-responsive {
        flex-direction: column;
    }
    .contact-btn {
        display: none !important;
    }
    .contact-button-container {
        justify-content: flex-start;
        font-size: 12px;
        padding-left: 5px;
    }
    .contact-btn.mobile {
        display: flex !important;
        width: 100px !important;
        justify-content: flex-start;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        height: 40px !important;
    }

    >>>.profile-detail-block {
        padding: 0px !important;
    }

    .profile-header {
        padding: 4px !important;
    }

    .profile-header-block p{
        font-size: 12px;
    }

    .company-name-block {
        margin-right: 50px;
    }
    
    .sent-date {
        font-size: 10px !important;
    }

    .profile-subject-block {
        font-size: 12px;
        text-align: left;
        margin-top: -20px;
        /* margin-left: 11px; */
    }

    .preview-block {
        font-size: 12px;
        padding-left: 5px;
        padding-right: 5px;
    }

    .preview-body >>>p {
        line-height: 18px !important;
    }

    .button-container {
        padding: 15px 2px 15px 2px;
    }

    .submit-text-button,
    .question-button,
    .cancel-text-button {
        padding: 2px !important;
        border-radius: 4px !important;
        font-size: 11px;
        font-weight: bold;
        margin-right: 2px !important;
        margin-left: 2px !important;
        height: 40px !important;
        width: 125px !important; 
    }

    .info-container p {
        line-height: 5px;
        padding: 10px 0px 0px 0px;
    }
    .info-container ul {
        padding: 5px 10px;
        font-size: 11px;
    }
}

@media(max-width: 550px) {
    >>>.profile-detail-block {
        padding: 0px !important;
    }

    .desktop {
        display: none;
    }

    .reply-detail-full {
        width: 100%;
    }

    /* .company-name-block { */
        /* margin-left:10px;
    } */
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    .preview-block {
        padding:20px;
    }
    .company-name-block {
        margin-left:20px;
    }

    .profile-subject-block{
        text-align: left;
    }

    .reply-detail {
        width: 30%;
    }
}

</style>